<script lang="ts" setup>
// @ts-expect-error JS file
import store from '@/store'
import { eventApi } from '@/enitites/event'
import IconLike from '@/shared/icons/IconLike.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'

const props = defineProps<{
  eventId: number
  isLiked: boolean
  totalLikes?: number
  colorSvg?: string
}>()

const emit = defineEmits<{
  (e: 'update:is-liked', value: boolean): void
  (e: 'update:total-likes', value: number): void
}>()

const getUserDB = computed(() => store.getters.getUserDB)
const router = useRouter()
const route = useRoute()

const handleToggleLike = async () => {
  if (!getUserDB.value) {
    await router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
    return
  }
  const previousState = props.isLiked
  const previousTotalLikes = props.totalLikes

  emit('update:is-liked', !previousState)
  if (props.totalLikes !== undefined) {
    emit('update:total-likes', previousTotalLikes !== undefined ? previousTotalLikes + (previousState ? -1 : 1) : 1)
  }

  const response = await eventApi.toggleLike(props.eventId)

  if (response === undefined) {
    emit('update:is-liked', previousState)
    if (props.totalLikes !== undefined) {
      emit('update:total-likes', previousTotalLikes)
    }
  }
}
</script>

<template>
  <button
    class="toggle-like"
    @click.stop="handleToggleLike"
  >
    <span v-if="!isLiked">Leave a like</span>
    <span v-else>You like it!</span>
    <IconLike
      :fill="isLiked"
      :color="colorSvg"
    />
    <span v-if="totalLikes !== undefined">{{ totalLikes }}</span>
  </button>
</template>

<style lang="scss" scoped>
.toggle-like {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
